module.exports = __webpack_public_path__ + "img/message2.03c68cec.png";